<template>
  <b-container>
    <b-row>
      <b-col cols="4">
        <DateInput v-model="fromDate"></DateInput>
      </b-col>
      <b-col cols="4">
        <DateInput v-model="toDate"></DateInput>
      </b-col>
      <b-col cols="4">
        <b-form-select v-model="interval" :options="intervalOptions"></b-form-select>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col cols="6">
        <b-form-select v-model="selectedCorporateVendorId" :options="corporateVendorOptions"></b-form-select>
      </b-col>
      <b-col cols="6">
        <b-button-group block class="w-100">
          <b-button @click="getData">{{ $t('admin_report.show_report') }}</b-button>
          <b-button variant="light" @click="exportData">
            <font-awesome-icon icon="file-export"></font-awesome-icon>
          </b-button>
        </b-button-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <LineChart :chart-data="chartData" height="200px"></LineChart>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {DateTime} from 'luxon'
import DateInput from "../DateInput";
import _ from 'lodash';
import LineChart from "./LineChart";
import {library} from '@fortawesome/fontawesome-svg-core'
import {faFileExport} from '@fortawesome/free-solid-svg-icons'

library.add(faFileExport);

export default {
  name: 'CorporateVendorViewCountReport',
  components: {LineChart, DateInput},
  data() {
    return {
      fromDate: DateTime.local().startOf('year').toISO(),
      toDate: DateTime.local().endOf('year').toISO(),
      interval: 1,
      intervalOptions: [
        {value: 1, text: this.$t('admin_report.interval_month')},
        {value: 12, text: this.$t('admin_report.interval_year')},
      ],

      selectedCorporateVendorId: null,
      corporateVendors: [],
      rawData: null,
    }
  },
  computed: {
    corporateVendorOptions() {
      return _.concat(
          [{value: null, text: this.$t('all')}],
          this.corporateVendors.map(function (p) {
            return {value: p.id, text: p.name};
          }));
    },
    chartData() {
      if (!this.rawData) {
        return {}
      }

      let labels = this.rawData[0].data.map(function (d) {
        return d.label;
      });

      return {
        labels: labels,
        datasets: this.rawData.map(function (d) {
          let color = 'rgba(' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', ' + Math.floor(Math.random() * Math.floor(255)) + ', 0.5)';

          let data = d.data.map(function (d) {
            // return Math.floor(Math.random() * Math.floor(10));
            return d.value;
          });

          return {
            backgroundColor: color,
            label: d.label,
            data: data,
          }
        }),
      }
    },
  },
  mounted() {
    this.getCorporateVendors();
  },
  methods: {
    getCorporateVendors() {
      this.$callAPI('hkiarace/admin/corporate_vendor/', {}, function (response) {
        this.corporateVendors = response.body.vendors;
      });
    },
    getData() {
      this.$callAPI('hkiarace/admin/report/', {
        report_type: 'CORPORATE_VENDOR_VIEW_COUNT',
        params: {
          from: DateTime.fromISO(this.fromDate).toSeconds(),
          to: DateTime.fromISO(this.toDate).toSeconds(),
          interval: this.interval,
          vendor_id: this.selectedCorporateVendorId,
        },
      }, function (response) {
        this.rawData = response.body.datasets;
      })
    },
    exportData() {
      this.$downloadFile('hkiarace/admin/report/export/', {
        report_type: 'CORPORATE_VENDOR_VIEW_COUNT',
        params: {
          from: DateTime.fromISO(this.fromDate).toSeconds(),
          to: DateTime.fromISO(this.toDate).toSeconds(),
          interval: this.interval,
          vendor_id: this.selectedCorporateVendorId,
        },
      }, 'export.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    },
  },
}
</script>

<style>

</style>
